import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export default function CityCard({ city }) {
  return (
    <Link
      to={`/cidades/${city.slug}`}
      data-testid={`city-card-${city.slug}`}
      className="card-rotta group block"
    >
      <div className="img-zoom relative aspect-[4/5] overflow-hidden">
        {city.cover_image && <img src={city.cover_image} alt={city.name} loading="lazy" className="w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#C6A762] mb-2">
            <MapPin size={12} /> {city.state}
          </div>
          <h3 className="font-display text-3xl text-white group-hover:text-[#C6A762] transition-colors">
            {city.name}
          </h3>
          <p className="mt-2 text-sm text-white/75 line-clamp-2">{city.short_description}</p>
        </div>
      </div>
    </Link>
  );
}
